import { loc } from "../../../core/utils"
import NumberField from "../../../form/NumberField"
import Select from "../../../form/Select"
import TextField from "../../../form/TextField"
import { apigateway } from "../../../intances/apigateway"
import "../styles.css"
import validate from "./validator"
import React, { useEffect } from "react"
import { Button, Col, Row } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"
import * as FinalForm from "react-final-form"
import toast from "react-hot-toast"

const ProductCreationModal = ({ tunnelData, apiUrl, token, formValues, updateField }) => {
  const [show, setShow] = React.useState(false)
  const [shopId, setShopId] = React.useState("")
  const [productCategory, setProductCategory] = React.useState({})

  useEffect(() => {
    setShopId(formValues?.shop?.value.split("-")[0])
    setProductCategory(formValues?.products[0].category)
  }, [formValues])

  function filterFamilyOptions(items) {
    return items
      .map((item) => {
        return {
          value: item.parent.parentCategoryId,
          label: item.parent.labelCategoryParent
        }
      })
      .filter((element, index, self) => self.findIndex((e) => element.value === e.value) === index)
  }

  function filterCategoryOptions(items) {
    if (items[0].children.length > 0) {
      return items[0].children
        .map((item) => {
          return { value: item.id, label: item.label }
        })
        .filter((element, index, self) => self.findIndex((e) => element.value === e.value) === index)
    }
    return items
      .map((item) => {
        return {
          value: item.parent.id,
          label: item.parent.label
        }
      })
      .filter((element, index, self) => self.findIndex((e) => element.value === e.value) === index)
  }

  const onSubmit = async (values) => {
    const payload = {
      skuDistributor: values.sku,
      categoryEvollis: {
        id: values.category.value
      },
      priceIncTaxes: values.price,
      brand: values.brand,
      designation: values.description,
      smallDescription: values.description,
      bigDescription: values.description,
      active: true
    }
    const id = toast.loading(loc("create_product_inprogress_toast"))
    apigateway(tunnelData, shopId)
      .post("middle-business-service/api/v1/products/save", payload)
      .then((response) => {
        const { data } = response
        updateField({
          sku: createSkuValueFromProductCreation(data)
        })
      })
      .then(() => {
        toast.success(loc("create_product_success_toast"), { id })
        setShow(false)
      })
      .catch((_error) => {
        toast.error(loc("create_product_error_toast"), { id })
      })
  }

  return (
    <>
      <button className="create-product" onClick={() => setShow(true)}>
        {loc("simulation_button_create_product")}
      </button>
      <Modal show={show} backdrop="static" keyboard={false}>
        <Modal.Header className="create-product-modal_header">
          <div id="dropin-container">{loc("create_product_title")}</div>
        </Modal.Header>
        <Modal.Body>
          <FinalForm.Form
            validate={validate}
            onSubmit={onSubmit}
            render={({ handleSubmit, values }) => {
              return (
                <>
                  <Row>
                    <Col xs={12}>
                      <TextField name="sku" label={loc("simulation_product_input_label")} />
                    </Col>
                    <Col xs={12}>
                      <Select
                        name="family"
                        label={loc("simulation_family_input_label")}
                        url={`${apiUrl}middle-business-service/api/v1/categories/by-supplierid/${shopId}`}
                        token={token}
                        extract={filterFamilyOptions}
                        oneElement={true}
                      />
                    </Col>
                    <Col xs={12}>
                      {productCategory == null ? (
                        <Select
                          name="category"
                          label={loc("simulation_category_input_label")}
                          url={
                            values.family &&
                            `${apiUrl}middle-business-service/api/v1/categories/by-category/${shopId}?parentCategoryId=${values.family.value}`
                          }
                          token={token}
                          disabled={!values.family}
                          extract={filterCategoryOptions}
                          oneElement={true}
                        />
                      ) : (
                        <Select
                          name="category"
                          label={loc("simulation_category_input_label")}
                          options={[productCategory]}
                          disabled={!values.family}
                          oneElement={true}
                        />
                      )}
                    </Col>

                    <Col xs={12}>
                      <TextField name="brand" label={loc("simulation_brand_input_label")} />
                    </Col>

                    <Col xs={12}>
                      <TextField name="description" label={loc("simulation_description_input_label")} />
                    </Col>

                    <Col xs={12}>
                      <NumberField name="price" label={loc("simulation_price_input_label")} />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6} lg={6}>
                      <Button
                        variant="danger"
                        onClick={() => {
                          setShow(false)
                        }}
                      >
                        {loc("button_cancel")}
                      </Button>
                    </Col>
                    <Col md={6} lg={6}>
                      <Button variant="outline-primary" onClick={handleSubmit}>
                        {loc("Validate")}
                      </Button>
                    </Col>
                  </Row>
                </>
              )
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ProductCreationModal

function createSkuValueFromProductCreation(data) {
  return {
    value: {
      priceIncTaxes: data?.priceIncTaxes,
      designation: data?.designation,
      sku: data?.sku,
      picture: data?.picture,
      skuDistributor: data?.skuDistributor,
      categoryEvollis: {
        id: data?.categoryEvollis?.id,
        label: data?.categoryEvollis?.label,
        categoryLevelParameters: data?.categoryEvollis?.categoryLevelParameters,
        labelCategoryParent: data?.categoryEvollis?.labelCategoryParent,
        parentCategoryId: data?.categoryEvollis?.parentCategoryId,
        rootLabelCategory: data?.categoryEvollis?.rootLabelCategory,
        mainProduct: data?.categoryEvollis?.mainProduct
      },
      id: data?.id,
      brand: data?.brand,
      active: data?.active,
      supplierId: data?.supplierId,
      mainProduct: data?.mainProduct
    },
    label: data?.skuDistributor
  }
}
